function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.02637 13.9017H10.973V15.8483H9.02637V13.9017Z",
  fill: "#9A8EDE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0003 4.15171C7.84635 4.15171 6.09863 5.8952 6.09863 8.04917H8.04948C8.04948 6.97853 8.92969 6.09833 10.0003 6.09833C11.071 6.09833 11.9512 6.97853 11.9512 8.04917C11.9512 10 9.02702 9.75458 9.02702 12.9242H10.9736C10.9736 10.7321 13.902 10.4867 13.902 8.04917C13.902 5.8952 12.1543 4.15171 10.0003 4.15171Z",
  fill: "#9A8EDE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0.25C4.61719 0.25 0.25 4.61719 0.25 10C0.25 15.3828 4.61719 19.75 10 19.75C15.3828 19.75 19.75 15.3828 19.75 10C19.75 4.61719 15.3828 0.25 10 0.25ZM10 17.7992C5.70052 17.7992 2.20085 14.2995 2.20085 10C2.20085 5.70052 5.70052 2.20085 10 2.20085C14.2995 2.20085 17.7992 5.70052 17.7992 10C17.7992 14.2995 14.2995 17.7992 10 17.7992Z",
  fill: "#9A8EDE"
});

var SvgQuestion = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question.3975ad6c.svg";
export { ForwardRef as ReactComponent };